import React from "react";
import { Target, Trophy, MapPin, TrendingUp, Filter } from "lucide-react";

const TALENT = [
  { name: "Aarav S.", region: "Jaipur, RJ", game: "VALORANT", rating: 92, traits: ["IGL", "Aim+"], tier: "Tier-1 Ready" },
  { name: "Meera K.", region: "Kochi, KL", game: "BGMI", rating: 88, traits: ["Sniper", "Team"], tier: "Scout" },
  { name: "Ishaan P.", region: "Indore, MP", game: "FC 26", rating: 85, traits: ["Strategy"], tier: "Scout" },
  { name: "Zara A.", region: "Guwahati, AS", game: "Street Fighter", rating: 91, traits: ["Clutch"], tier: "Tier-1 Ready" },
];

export default function ScoutingPortalMock() {
  return (
    <div className="glass-strong rounded-2xl p-6 md:p-8 relative overflow-hidden" data-testid="scouting-portal-mock">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-[#FF8C00] shadow-[0_0_12px_#FF8C00] animate-pulse" />
          <p className="text-xs font-mono-tech uppercase tracking-widest text-[#FF8C00]">Scouting Portal · Beta</p>
        </div>
        <div className="flex items-center gap-2 text-xs font-mono-tech text-[#6a6a70]">
          <Filter className="w-3 h-3" /> FILTERS: PRO-PATH L3+ · WELLNESS-CLEARED
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <Kpi label="Athletes" value="12,480" delta="+18%" />
        <Kpi label="Tier-1 Ready" value="342" delta="+4" />
        <Kpi label="States" value="28" delta="Pan-India" />
        <Kpi label="Signings YTD" value="57" delta="+12%" />
      </div>

      <div className="grid grid-cols-12 gap-2 px-3 py-2 text-[10px] font-mono-tech uppercase tracking-widest text-[#6a6a70] border-b border-white/8">
        <div className="col-span-4">Athlete</div>
        <div className="col-span-3 hidden md:block">Region</div>
        <div className="col-span-2">Game</div>
        <div className="col-span-3 md:col-span-3 text-right">Perforange Score</div>
      </div>

      <div className="divide-y divide-white/8">
        {TALENT.map((t, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 items-center px-3 py-3 hover:bg-white/3 transition-colors">
            <div className="col-span-4 flex items-center gap-3 min-w-0">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#FF8C00] to-[#FF5A00] flex items-center justify-center text-[#0A0A0C] font-bold text-sm shrink-0">
                {t.name[0]}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-bold text-white truncate">{t.name}</p>
                <p className="text-[10px] uppercase tracking-widest text-[#6a6a70]">{t.tier}</p>
              </div>
            </div>
            <div className="col-span-3 hidden md:flex items-center gap-1 text-xs text-[#A1A1AA]">
              <MapPin className="w-3 h-3" /> {t.region}
            </div>
            <div className="col-span-2 text-xs text-[#D4D4D8] font-mono-tech">{t.game}</div>
            <div className="col-span-3 md:col-span-3 flex items-center justify-end gap-3">
              <div className="w-20 h-1.5 bg-white/5 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#FF8C00] to-[#FFB05E]"
                  style={{ width: `${t.rating}%` }}
                />
              </div>
              <span className="text-sm font-black text-[#FF8C00] font-mono-tech w-8 text-right">{t.rating}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Kpi({ label, value, delta }) {
  return (
    <div className="glass rounded-xl p-4">
      <div className="flex items-center gap-2">
        <Trophy className="w-3.5 h-3.5 text-[#FF8C00]" />
        <p className="text-[10px] uppercase tracking-widest text-[#6a6a70]">{label}</p>
      </div>
      <p className="mt-2 text-2xl font-black text-white">{value}</p>
      <p className="text-[11px] text-[#00FFD0] font-mono-tech flex items-center gap-1">
        <TrendingUp className="w-3 h-3" /> {delta}
      </p>
    </div>
  );
}
